




























































































































import { Vue, Component, Prop } from "vue-property-decorator"
import VideoOnVideoInfo from "../../models/VideoOnVideoInfo"
import { MomentInfo } from "../../models/MomentInfo"
const shaka = require("shaka-player/dist/shaka-player.ui")
import "shaka-player/dist/controls.css"
import "../../assets/plyr.css"
import "../../assets/vendor/bootatrap-grid.css"
import "../../assets/_base.scss"
import SwapButton from "../VideoPlayerCustomButtons/SwapButton"
import { VideoInfo } from "../../models/VideoInfo"
var SocialSharing = require("vue-social-sharing")
import CaptionButton from "../VideoPlayerCustomButtons/CaptionButton"
import loadDuration from "../../services/loadDuration"
import replaceHtmlClass from "../../services/replaceHtmlClass"

Vue.use(SocialSharing)
@Component
export default class extends Vue {
  @Prop() private momentsData!: VideoOnVideoInfo
  @Prop({ default: false }) private islast!: boolean
  private get baseVideo(): HTMLVideoElement {
    return this.$refs.baseVideo as HTMLVideoElement
  }
  private get pipVideo(): HTMLVideoElement {
    return this.$refs.pipVideo as HTMLVideoElement
  }

  private get baseContainer(): HTMLElement {
    return this.$refs.baseContainer as HTMLElement
  }
  private get pipContainer(): HTMLElement {
    return this.$refs.pipContainer as HTMLElement
  }
  isposter = true
  baseVideoData: VideoInfo = this.momentsData.video_big
  pipVideoData: VideoInfo = this.momentsData.video_small
  stright: boolean = true
  currentTime: number = 0
  timeoutId = 0
  //shaka ui
  durationElement?: HTMLElement
  playbuttonElement?: HTMLElement
  bottomControlElement?: HTMLElement
  skimElement?: HTMLElement
  seekbarelement?: HTMLElement
  seekbarbufferedelement?: HTMLElement
  shakacontrolsContainerElement?: HTMLElement
  seektimeout = 0
  mounted() {
    shaka.polyfill.installAll()
    const baseplayer = new shaka.Player(this.baseVideo)
    const pipPlayer = new shaka.Player(this.pipVideo)
    var self = this
    SwapButton.Factory = class {
      create(rootElement: any, controls: any) {
        return new SwapButton(
          rootElement,
          controls,
          self.onSwap,
          baseplayer,
          pipPlayer
        )
      }
    }

    CaptionButton.Factory = class {
      create(rootElement: any, controls: any) {
        return new CaptionButton(rootElement, controls, pipPlayer)
      }
    }

    // Register our factory with the controls, so controls can create button instances.
    shaka.ui.Controls.registerElement("captions", new CaptionButton.Factory())
    shaka.ui.Controls.registerElement("swap", new SwapButton.Factory())
    //load base video
    const uiConfig = {
      controlPanelElements: [],
      addSeekBar: false,
      addBigPlayButton: false
    }
    const ui = new shaka.ui.Overlay(
      baseplayer,
      this.baseContainer,
      this.baseVideo
    )
    ui.configure(uiConfig)

    //load pip video
    const pipUiConfig = {
      controlPanelElements: [
        "play_pause",
        "time_and_duration",
        "mute",
        "volume",
        "captions",
        "swap"
      ],
      addSeekBar: true,
      doubleClickForFullscreen: false
    }
    const pipUi = new shaka.ui.Overlay(
      pipPlayer,
      this.pipContainer,
      this.pipVideo
    )
    pipUi.configure(pipUiConfig)
    let controls = pipUi.getControls()
    controls
      .getControlsContainer()
      .getElementsByClassName("shaka-mute-button")[0]
      .addEventListener("click", this.onMuted)

    if (shaka.Player.isBrowserSupported()) {
      baseplayer.configure({
        abr: {
          defaultBandwidthEstimate: 640000000 // 8 MB/s or 64e7 bits/s
        },
        streaming: {
          jumpLargeGaps: true,
          bufferingGoal: 120,
          failureCallback: () => {
            console.error("Video Buffering failed")
          }
        }
      })
      pipPlayer.configure({
        abr: {
          defaultBandwidthEstimate: 640000000 // 8 MB/s or 64e7 bits/s
        },
        streaming: {
          jumpLargeGaps: true,
          bufferingGoal: 120,
          failureCallback: () => {
            console.error("Video Buffering failed")
          }
        }
      })
      this.loadPlayers(
        baseplayer,
        this.baseVideoData.dash_url,
        pipPlayer,
        this.pipVideoData.dash_url,
        0
      ).then(() => {
        pipUi
          .getControls()
          .getControlsContainer()
          .getElementsByClassName("shaka-seek-bar-container")[0]
          .classList.add("not-on-iphone")
      })
      this.durationElement = loadDuration(
        controls.getControlsContainer() as HTMLElement,
        this.momentsData.duration
      )
      this.playbuttonElement = (controls.getControlsContainer() as HTMLElement).getElementsByClassName(
        "shaka-play-button-container"
      )[0] as HTMLElement
      this.bottomControlElement = (controls.getControlsContainer() as HTMLElement).getElementsByClassName(
        "shaka-bottom-controls"
      )[0] as HTMLElement
      this.bottomControlElement.classList.add("hide")
      this.skimElement = (controls.getControlsContainer() as HTMLElement).getElementsByClassName(
        "shaka-skim-container"
      )[0] as HTMLElement
      this.skimElement.classList.add("hide")
      this.shakacontrolsContainerElement = controls.getControlsContainer() as HTMLElement
      this.shakacontrolsContainerElement.classList.add("opaque")
      this.seekbarelement = document.createElement("div")
      this.seekbarelement.classList.add("shaka-seek")
      this.seekbarbufferedelement = document.createElement("div")
      this.seekbarbufferedelement.classList.add("shaka-seek-buffered")
      ;((controls.getControlsContainer() as HTMLElement).getElementsByClassName(
        "shaka-seek-bar-container"
      )[0] as HTMLElement).appendChild(this.seekbarelement)
      ;((controls.getControlsContainer() as HTMLElement).getElementsByClassName(
        "shaka-seek-bar-container"
      )[0] as HTMLElement).appendChild(this.seekbarbufferedelement)
    }
    var self = this
    this.pipVideo.onprogress = function() {
      self.updateLoadedIndicator()
    }
    this.$root.$data.videoPlayers.push(this.baseVideo)
    this.addlisteners()
    this.baseVideo.muted = true
  }
  async loadPlayers(
    baseplayer: any,
    bigurl: string,
    pipPlayer: any,
    pipurl: string,
    currentTime: number
  ) {
    await baseplayer.load(bigurl, currentTime)
    await pipPlayer.load(pipurl, currentTime).then(() => {
      if (!!this.momentsData.subtitle_urls.web_vtt_url) {
        pipPlayer.addTextTrack(
          this.momentsData.subtitle_urls.web_vtt_url,
          "English",
          "captions",
          "text/vtt"
        )
      }
    })
  }
  addlisteners() {
    this.baseVideo.addEventListener("play", this.onplayingBase)
    this.pipVideo.addEventListener("play", this.onplayingPip)
    this.baseVideo.addEventListener("pause", this.onpauseBase)
    this.pipVideo.addEventListener("pause", this.onpausePip)
    this.pipVideo.addEventListener("seeked", this.onSeeked)
    this.pipVideo.addEventListener("volumechange", this.onVolumeChange)
  }
  removelisteners() {
    this.baseVideo.removeEventListener("play", this.onplayingBase)
    this.pipVideo.removeEventListener("play", this.onplayingPip)
    this.baseVideo.removeEventListener("pause", this.onpauseBase)
    this.pipVideo.removeEventListener("pause", this.onpausePip)
    this.pipVideo.removeEventListener("seeked", this.onSeeked)
    this.pipVideo.removeEventListener("volumechange", this.onVolumeChange)
  }
  onMuted() {
    if (this.stright) {
      this.baseVideo.muted = true
    } else {
      this.pipVideo.muted = true
      this.baseVideo.muted = !this.baseVideo.muted
    }
  }
  onVolumeChange() {
    this.baseVideo.volume = this.pipVideo.volume
    if (this.stright) {
      this.baseVideo.muted = true
    } else {
      this.pipVideo.muted = true
    }
  }
  onSeeked() {
    if (this.pipVideo.currentTime < this.baseVideo.duration) {
      this.baseVideo.currentTime = this.pipVideo.currentTime
    } else {
      this.baseVideo.currentTime = this.baseVideo.duration
    }
  }
  onplayingPip() {
    this.isposter = false
    if (this.pipVideo.currentTime < this.baseVideo.duration) {
      this.baseVideo.currentTime = this.pipVideo.currentTime
      this.baseVideo.play()
    } else {
      this.baseVideo.pause()
    }
    if (this.playbuttonElement) {
      this.playbuttonElement.classList.add("hide")
    }
    replaceHtmlClass(this.durationElement, "show", "hide")
    replaceHtmlClass(this.bottomControlElement, "hide", "show")
    replaceHtmlClass(this.skimElement, "hide", "show")
    replaceHtmlClass(this.shakacontrolsContainerElement, "opaque", "")
    this.seektimeout = setTimeout(() => {
      this.updateSeekbar()
    }, 500)
  }
  onplayingBase() {
    this.$root.$data.videoPlayers.forEach((player: any) => {
      if (player != this.baseVideo) {
        player.pause()
      }
    })
    if (this.baseVideo.currentTime < this.pipVideo.duration) {
      this.pipVideo.currentTime = this.baseVideo.currentTime
      this.pipVideo.play()
    } else {
      this.pipVideo.currentTime = this.pipVideo.duration
      this.pipVideo.pause()
    }
    window.requestAnimationFrame(this.sync)
  }
  onpausePip() {
    this.baseVideo.pause()
    clearTimeout(this.seektimeout)
  }
  onpauseBase() {
    this.pipVideo.pause()
  }
  updateLoadedIndicator() {
    if (this.seekbarbufferedelement && this.pipVideo.buffered.length > 0) {
      this.seekbarbufferedelement.setAttribute(
        "style",
        `width:${((this.pipVideo.buffered.end(0) - this.pipVideo.currentTime) /
          this.pipVideo.duration) *
          100}% !important`
      )
    }
  }
  updateSeekbar() {
    clearTimeout(this.seektimeout)

    if (this.seekbarelement) {
      this.seekbarelement.setAttribute(
        "style",
        `width:${(this.pipVideo.currentTime / this.pipVideo.duration) *
          100}% !important`
      )
    }
    if (this.seekbarbufferedelement && this.pipVideo.buffered.length > 0) {
      this.seekbarbufferedelement.setAttribute(
        "style",
        `width:${((this.pipVideo.buffered.end(0) - this.pipVideo.currentTime) /
          this.pipVideo.duration) *
          100}% !important`
      )
    }
    this.seektimeout = setTimeout(() => {
      this.updateSeekbar()
    }, 500)
  }
  sync() {
    if (
      this.baseVideo.readyState == 4 &&
      this.pipVideo.readyState == 4 &&
      this.baseVideo.currentTime != this.pipVideo.currentTime
    ) {
      this.pipVideo.currentTime = this.baseVideo.currentTime
    } else {
    }
  }
  onSwap(basePlayer: any, pipPlayer: any) {
    this.currentTime =
      this.baseVideo.currentTime > this.pipVideo.currentTime
        ? this.baseVideo.currentTime
        : this.pipVideo.currentTime
    this.baseVideo.pause()
    this.pipVideo.pause()
    this.onpauseBase()
    this.onpausePip()
    if (this.stright) {
      this.baseVideo.muted = this.pipVideo.muted
      this.pipVideo.muted = true
      this.loadPlayers(
        basePlayer,
        this.pipVideoData.dash_url,
        pipPlayer,
        this.baseVideoData.dash_url,
        this.currentTime
      )
      this.baseVideo.pause()
      this.pipVideo.pause()
      this.stright = false
    } else {
      this.pipVideo.muted = this.baseVideo.muted
      this.baseVideo.muted = true
      this.loadPlayers(
        basePlayer,
        this.baseVideoData.dash_url,
        pipPlayer,
        this.pipVideoData.dash_url,
        this.currentTime
      )
      this.stright = true
    }
  }
  beforeDestroy() {
    this.removelisteners()
  }
}
